import { useCallback, useState } from "react";

/**
 * useHeaderContextMenu
 * State for the right-click menu on column / row headers
 * (Hide / Unhide).  Kept separate from the freeze-pane context menu
 * so they can never be open at the same time.
 */
export default function useHeaderContextMenu() {
  const [headerCtx, setHeaderCtx] = useState(null); // { type, index, x, y }

  const handleHeaderContextMenu = useCallback((e, type, index) => {
    e.preventDefault();
    e.stopPropagation();
    setHeaderCtx({ type, index, x: e.clientX, y: e.clientY });
  }, []);

  const closeHeaderContextMenu = useCallback(() => setHeaderCtx(null), []);

  return { headerCtx, handleHeaderContextMenu, closeHeaderContextMenu };
}
